import { __decorate } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import KeyCode from 'choerodon-ui/lib/_util/KeyCode';
import { ProgressType } from 'choerodon-ui/lib/progress/enum';
import { CheckBox } from '../check-box/CheckBox';
import Progress from '../progress';
import { Size } from '../core/enum';
import autobind from '../_util/autobind';
import isOverflow from '../overflow-tip/util';
import { show } from '../tooltip/singleton';
let Switch = class Switch extends CheckBox {
    handleKeyDown(e) {
        if (e.keyCode === KeyCode.LEFT) {
            this.setChecked(false);
        }
        else if (e.keyCode === KeyCode.RIGHT) {
            this.setChecked(true);
        }
        super.handleKeyDown(e);
    }
    showTooltip(e) {
        const { currentTarget } = e;
        const { props: { children, unCheckedChildren }, } = this;
        const switchLabel = currentTarget.nextElementSibling;
        const text = this.isChecked() ? children : unCheckedChildren || children;
        if (text && isOverflow(switchLabel)) {
            show(currentTarget, {
                title: text,
            });
            return true;
        }
        return false;
    }
    getOmitPropsKeys() {
        return super.getOmitPropsKeys().concat([
            'loading',
        ]);
    }
    isDisabled() {
        if (super.isDisabled()) {
            return true;
        }
        const { loading = false } = this.props;
        return loading;
    }
    getLabelText() {
        return undefined;
    }
    getTextNode() {
        const { prefixCls, props: { children, unCheckedChildren }, } = this;
        const text = this.isChecked() ? children : unCheckedChildren || children;
        return (React.createElement("span", { className: `${prefixCls}-label` }, text ? React.createElement("span", { className: `${prefixCls}-label-content` }, text) : null));
    }
    renderSwitchFloatLabel() {
        const { prefixCls, } = this;
        return (React.createElement("span", { className: `${prefixCls}-float-label` }, this.getLabelChildren()));
    }
    getWrapperClassNames() {
        const { prefixCls, props: { loading, }, } = this;
        return super.getWrapperClassNames({
            [`${prefixCls}-loading`]: loading,
        });
    }
    renderInner() {
        const { loading } = this.props;
        if (loading) {
            return (React.createElement(Progress, { key: "loading", type: ProgressType.loading, size: Size.small }));
        }
        return null;
    }
};
Switch.displayName = 'Switch';
/**
 * tooltip disable sign
 */
// eslint-disable-next-line camelcase
Switch.__PRO_SWITCH = true;
// eslint-disable-next-line camelcase
Switch.__IS_IN_CELL_EDITOR = true;
Switch.defaultProps = {
    ...CheckBox.defaultProps,
    suffixCls: 'switch',
};
__decorate([
    autobind
], Switch.prototype, "handleKeyDown", null);
Switch = __decorate([
    observer
], Switch);
export default Switch;
